<template>
  <div class="singleSet" v-if="org">
    <!-- 出單貼紙設定 -->
    <RadioTop v-if="mode==='single'" :options="['商品內容', '材料組成', '成分|營養標示', '其他圖片']" :defaultValue="subpage" @input="subpage=$event"></RadioTop>
    <RadioTop v-else :options="['商品內容', '其他圖片']" :defaultValue="subpage" @input="subpage=$event"></RadioTop>
    <template  v-if="subpage==='商品內容'">
    <div class="cube">
        <EditBtn v-if="!edit" @click="edit=true" class="topright" :style="{boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)', zIndex: 10}"/>
        <template v-if="!edit">
          <div class="cube-body">
            <div class="fields">
              <div label="編號">{{org.id||'-'}}</div>
              <div label="名稱">{{org.name||'-'}}</div>
              <div label="名稱2">{{org.name2||'-'}}</div>
              <div label="類別" v-if="mode==='single'">{{org.category||'-'}}</div>
              <div label="類別" v-else>{{org.type||'-'}}</div>
              <div label="販售單位">{{org.unit||'-'}}</div>
              <div label="商品售價" :style="{fontWeight: 700}">{{org.price||'-'}}</div>
              <div label="販售時間" :style="{flexWrap: 'nowrap'}"><span>{{org.onsaleTime?.start}} ~ {{org.onsaleTime?.end}}</span></div>
            </div>
            <div class="fields" :style="{gap:'5px'}">
              <div label="商品圖" class="blue"></div>
              <div class="img" :style="{backgroundImage: `url(${VUE_APP_HOST}${org.image?org.image:'/userPic.png'})`}"></div>
            </div>
          </div>
          <div class="foot">
            <div>建立時間 | {{toDateTime(org.createTime)}}</div>
            <div>最後修改時間 | {{toDateTime(org.updateTime)}}</div>
          </div>
        </template>
        <template v-else>
          <div class="cube-body">
            <div class="fields">
              <div label="編號">{{editItem.id}}</div>
              <div label="名稱"><input type="text" :style="{width: '320px'}" v-model="editItem.name"></div>
              <div label="名稱2"><input type="text" :style="{width: '320px'}" v-model="editItem.name2"></div>
              <div label="商品用途"  v-if="mode==='single'"><Select :style="{textAlign: 'center'}" :defaultValue="editItem.type" :height="'35px'" :width="'200px'" @input="editItem.type=$event">
                <option v-for="(ty, t) in usages" :key="t" :value="ty">{{ty}}</option></Select></div>

              <div label="類別" v-if="mode==='single'"><Select :style="{textAlign: 'center'}" :defaultValue="editItem.category" :height="'35px'" :width="'200px'" @input="editItem.category=$event">
                <option v-for="(ty, t) in types" :key="t" :value="ty">{{ty}}</option>
              </Select></div>
              <div label="類別" v-else><Select :style="{textAlign: 'center'}" :defaultValue="editItem.type" :height="'35px'" :width="'200px'" @input="editItem.type=$event">
                <option v-for="(ty, t) in types" :key="t" :value="ty">{{ty}}</option>
              </Select></div>
              <div label="販售單位">{{editItem.unit}}</div>
              <div label="商品售價">{{editItem.price}}</div>
              <div label="販售時間">
                <div :style="{display: 'flex'}">
                  <TimeInput :defaultValue="editItem.onsaleTime.start" @input="editItem.onsaleTime.start=$event " :style="{width: '160px'}"/>
                  ~
                  <TimeInput :defaultValue="editItem.onsaleTime.end" @input="editItem.onsaleTime.end=$event " :style="{width: '160px'}"/>
                </div>
              </div>
            </div>
            <div class="fields" :style="{gap:'5px'}">
              <div label="商品圖" class="blue"></div>
              <div v-if="editItem.image" @click="editItem.image=null" class="img" :style="{backgroundImage: `url(${VUE_APP_HOST}${editItem.image})`}"></div>
              <File :defaultValue="editItem.image" @input="editItem.image=$event " :folder="'product'" :style="{borderRadius: '5px', width: '400px', height:'287px'}" v-else/>
            </div>
          </div>
          <Btns :style="{height: '40px', paddingBottom: '20px'}" @cancel="edit=false" @save="save"/>
        </template>
    </div>
    <Cube :title="'販售日(周)'" @edit="onsaleDay=JSON.parse(JSON.stringify((org.onsaleDay||[])));editSWD=true" :edit="editSWD" @save="saveSWD" @cancel="editSWD=false">
        <Checkbox2 :style="{flexDirection: 'row'} " slot="edit" v-if="editSWD " :options="wdoptions" :defaultValue="onsaleDay" @input="onsaleDay=$event"/>
        <div v-if="!editSWD" class="areas">
          <div class="area" v-for="wd in org.onsaleDay" :key="`wd-${wd}`">{{weekday[wd]}}</div>
        </div>
    </Cube>
    <Cube :title="'價格調整'" :noteditable="true" @edit="newprice={
        price: org.price, startTime: moment().add(1, 'day').format('YYYY-MM-DD'), expireTime: moment().add(5, 'year').format('YYYY-MM-DD')
      };editprice='new'" @cancel="editprice=false" @save="saveprice" :edit="editprice" id="priceModify">
      <template slot="btns">
        <button :style="{marginLeft: 'auto'}" v-if="!editprice" class="priceShift" @click="newprice={ time: moment(org.startTime || null).format('YYYY-MM-DD') };editprice='shift-start'" :title="'調整起始時間'">起</button>
        <button v-if="!editprice" class="priceShift" @click="newprice={ time: moment(org.expireTime || null).format('YYYY-MM-DD') };editprice='shift-expire'" :title="'調整到期時間'">迄</button>
        <button v-if="!editprice" class="priceShift" @click="newprice=org.excludeRange0 ? {start: null, end: null} : { start: moment(org.excludeRange0?.start).format('YYYY-MM-DD'), end: moment(org.excludeRange0?.end).format('YYYY-MM-DD') };editprice='excludeRange0'" :title="'調整排除期間'">Ex1</button>
        <button v-if="!editprice" class="priceShift" @click="newprice=org.excludeRange1 ? {start: null, end: null} : { start: moment(org.excludeRange1?.start).format('YYYY-MM-DD'), end: moment(org.excludeRange1?.end).format('YYYY-MM-DD') };editprice='excludeRange1'" :title="'調整排除期間'">Ex2</button>
      </template>
      <div class="fields" :style="{display: 'flex', flexDirection: 'row'}" v-if="editprice&&editprice==='new'" slot="edit">
        <div label="有效時間-起" :style="{alignItems:'start'}"><DateInput :style="{width: '230px'}" :defaultValue="newprice.startTime" @input="newprice.startTime=$event "/></div>
        <div label="有效時間-迄" :style="{alignItems:'start'}"><DateInput :style="{width: '230px'}" :defaultValue="newprice.expireTime" @input="newprice.expireTime=$event "/></div>
        <div label="原售價" :style="{alignItems:'start'}"><input type="text" :style="{width: '150px', textAlign: 'start', paddingInline:'1em'}" v-model="org.price"></div>
        <div label="新售價" :style="{alignItems:'start'}"><input type="text" :style="{width: '150px', textAlign: 'start', paddingInline:'1em', color: 'var(--highlight)', fontWeight: 700}" v-model="newprice.price"></div>
      </div>
      <div class="fields" :style="{display: 'flex', flexDirection: 'row'}" v-else-if="editprice&&editprice==='shift-start'" slot="edit">
        <div label="有效時間-起" :style="{alignItems:'start', flexDirection: 'row', alignItems:'center', gap: '20px'}"><DateInput :style="{width: '230px'}" :defaultValue="newprice.time" @input="newprice.time=$event "/></div>
      </div>
      <div class="fields" :style="{display: 'flex', flexDirection: 'row'}" v-else-if="editprice&&editprice==='shift-expire'" slot="edit">
        <div label="有效時間-迄" :style="{alignItems:'start', flexDirection: 'row', alignItems:'center', gap: '20px'}"><DateInput :style="{width: '230px'}" :defaultValue="newprice.time" @input="newprice.time=$event "/></div>
      </div>
      <div class="fields" :style="{display: 'flex', flexDirection: 'row'}" v-else-if="editprice&&(editprice==='excludeRange0' || editprice==='excludeRange1')" slot="edit">
        <div :label="`排除區間-${parseInt(editprice.slice(-1)) + 1}`" :style="{alignItems:'start', flexDirection: 'row', alignItems:'center', gap: '20px'}">
          <DateRange :style="{width: '430px'}" :defaultValue="newprice" @input="newprice=$event "/>
        </div>
      </div>
      <template v-else>
      <div class="fields" :style="{display: 'flex', flexDirection: 'row', gap: '70px'}">
        <div label="有效時間-起" :style="{alignItems:'start'}">{{toDate(org.startTime)}}</div>
        <div label="有效時間-迄" :style="{alignItems:'start'}">{{toDate(org.expireTime)}}</div>
        <div label="現售價" :style="{alignItems:'start'}">{{org.price}}</div>
      </div>
      <div class="fields" :style="{display: 'flex', flexDirection: 'row', gap: '70px', marginBlock: '20px'}">
        <div label="排除區間-1" :style="{alignItems:'start'}"><div v-if="org.excludeRange0?.start">{{toDate(org.excludeRange0.start)}} ~ {{toDate(org.excludeRange0.end)}}</div><div v-else>無</div></div>
        <div label="排除區間-2" :style="{alignItems:'start'}"><div v-if="org.excludeRange1?.start">{{toDate(org.excludeRange1.start)}} ~ {{toDate(org.excludeRange1.end)}}</div><div v-else>無</div></div>
      </div>
      </template>
      <div class="priceTimeline">
        <div  @click="() => {
          if (org.prePrice) {
            $router.replace({ name: $route.name, query: { ...$route.query, id: org.prePrice._id } })
          }
        }" :style="[org.prePrice ? {flex: 1} : {flex: .5, backgroundColor: '#DFDFDF'}]">{{org.prePrice?.price}}</div>
        <div id="startTime" :content="toDate(org.startTime)"></div>
        <div class="currentTime">{{org.price}}</div>
        <div id="expireTime" :content="toDate(org.expireTime)"></div>
        <div :style="[org.nextPrice ? {flex: 1} : {flex: .5, backgroundColor: '#DFDFDF'}]"
        @click="$router.replace({ name: $route.name, query: { ...$route.query, id: org.nextPrice._id } })">{{org.nextPrice?.price}}</div>
      </div>
    </Cube>
    <Cube :title="'商品說明'" @edit="desc=org.description;editdesc=true" @cancel="editdesc=false" @save="savedesc" :edit="editdesc" id="descriptionModify">
      <textarea slot="edit" v-model="desc"></textarea>
      <p v-html="org.description?.replaceAll('\n', '<br>')"></p>
    </Cube>
    <Cube :title="`組合內容-${org.items.length}項`" v-if="mode==='set'" @edit="$router.push({ name: $route.name, query: { page: '編輯組合', id: org._id } })">
      <div id="selectitemsCube">
        <div v-for="(itms, o) in org.items" :key="o" class="selectitems">
          <div v-if="itms.length>1">{{itms.length}} 選 1 | </div><div v-else>固定 | </div>
          <div><div v-for="(itm, p) in itms" :key="p">{{itm.item?.name || '商品不存在'}} x{{itm.count || 1}} ${{itm.item?.price}}</div></div>
        </div>
      </div>
      <div class="selectitems" v-if="org.coupons&&org.coupons.length>0">
        <div>優惠券</div>
        <div v-for="(itm, p) in org.coupons" :key="p">{{itm.item.couponName}} x{{itm.count}}</div>
      </div>
    </Cube>
    <Cube :title="'選項備註'" v-if="mode==='single'" @edit="option=(org.option || []);editopt=true" @cancel="editopt=false" @save="saveoption" :edit="editopt">
      <template slot="edit">
        <div class="editOptions">
            <div class="presetoptions">
              <div>常用選項</div>
              <div class="tags" :style="{padding: 0, border: 'none'}">
                <div v-for="(opt, o) in options" :key="`opt-${o}`" @click="optitems=JSON.parse(JSON.stringify(opt.items))">{{opt.name}}</div>
              </div>
            </div>
            <div class="presetoptions">
              <div>編輯選項</div>
              <div class="tags" @click="$refs.tag.focus()">
                <div v-for="(opt, o) in optitems" :key="`opt-${o}`" @click.stop="optitems.splice(o, 1)">{{opt}}</div>
                <input type="text" placeholder="選項標籤" ref="tag"
                v-model="optitem"
                @keypress.enter="optitems.push(optitem);optitem=null">
              </div>
              <SaveBtn :style="{height: '45px', width: '170px', fontSize: '16px', fontWeight: 400}" text="添加到列表" :disabled="optitems.length===0 "  bg="var(--color-pri)"
              :icon="'add'" @click="option.push(JSON.parse(JSON.stringify(optitems)));optitems=[]"></SaveBtn>
            </div>
            <div class="presetoptions">
              <div>商品選項</div>
              <div class="optionsProd">
                <div class="tags" v-for="(opt, o) in option" :key="`popt-${o}`">
                  <div v-for="(op, p) in opt" :key="`popt-${o}-${p}`" @click="option[o].splice(p, 1)">{{op}}</div>
                  <DelBtn :style="{marginLeft: 'auto'}" @click="option.splice(o, 1)"/>
                </div>
              </div>
            </div>
          </div>
      </template>
      <div class="optionsProd">
        <div class="tags" v-for="(opt, o) in org.option" :key="`popt-${o}`">
          <div v-for="(op, p) in opt" :key="`popt-${o}-${p}`">{{op}}</div>
        </div>
        </div>
    </Cube>
    <Cube :title="'加價選項'" v-if="mode==='single'" @edit="editAdd=true">
      <div class="tags">
        <div v-for="(op, p) in org.add" :key="`area-${p}`">{{op.name}} +{{op.price}}</div>
      </div>
    </Cube>
    <Cube :title="'區域'" @edit="area=JSON.parse(JSON.stringify((org.area||[])));editarea=true"
    :edit="editarea"
    @save="savearea" @cancel="editarea=false">
        <Checkbox :style="{flexDirection: 'row'}" slot="edit" v-if="editarea" :options="restaurants" :defaultValue="area" @input="area=$event"></Checkbox>
        <div v-if="!edit" class="areas">
          <div class="area" v-for="ar in org.area" :key="ar">{{ar}}</div>
        </div>
    </Cube>
    </template>
    <div v-else-if="subpage==='材料組成'" class="ingredbox">
      <Ingredient />
    </div>
    <template v-else-if="subpage==='成分|營養標示'">
      <LabelVue :org="org" @update="$emit('update', $event)"/>
    </template>
    <template v-else-if="subpage==='其他圖片'">
      <ImagesVue :org="org" :mode="mode" @update="$emit('update', $event)"/>
    </template>
    <div v-else class="printersetting">
      <PrinterVue v-for="(rest, r) in restaurants.filter(e => org.area.includes(e))" :id="org._id" :areas="org.area" :store="rest" :key="`rest-${r}`"/>
    </div>
    <Dialog :show="editAdd" :width="'607px'" :height="'700px'" :label="'加價客製'" @close="editAdd=false">
      <div class="dialog-body" style="{padding: 0}">
        <div :style="{display: 'flex', alignItems: 'center', paddingInline: '35px', justifyContent: 'space-between'}">
          <Select :defaultValue="usage" @input="usage=$event" :width="'192px'">
            <option v-for="us in usages" :key="us" :value="us">{{us}}</option>
          </Select>
          <SearchInput :width="'320px'" :defaultValue="searchText" @input="searchText=$event"/>
        </div>
        <div>
        <Table :rows="rows">
          <template slot="slot_head">
            <th :style="{width: '85px'}">選擇</th>
            <th :style="{textAlign: 'start'}">餐點名稱</th>
            <th>單位</th>
            <th>售價</th>
          </template>
          <tr slot-scope="{item}" :style="{height: '65px', borderBottom: 'none'}">
            <td><input type="checkbox" v-model="add" :value="item._id"></td>
            <td :style="{textAlign: 'start'}">{{item.name}}</td>
            <td>{{item.unit}}</td>
            <td>${{item.price}}</td>
          </tr>
        </Table>
        </div>
        <Btns :style="{display: 'flex'}" @cancel="editAdd=false" @save="saveadd"></Btns>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PrinterVue from './printer.vue'
import Ingredient from './ingredients.vue'
import DateRange from '../../../../components/input/dateRange.vue'
import DateInput from '../../../../components/input/date.vue'
import TimeInput from '../../../../components/input/time.vue'
import Checkbox from '../../../../components/checkbox/checkbox.vue'
import Checkbox2 from '../../../../components/checkbox/checkbox2.vue'
import SearchInput from '../../../../components/input/search.vue'
import Dialog from '../../../../components/dialognoPadding2.vue'
import Table from '../../../../components/tables/t2.vue'
import Select from '../../../../components/select.vue'
import DelBtn from '../../../../components/btn/del.vue'
import SaveBtn from '../../../../components/btn/round.vue'
import File from '../../../../components/input/file.vue'
import Btns from '../../../../components/btn/btns'
import Cube from '../../../../components/cube/prodcube.vue'
import RadioTop from '../../../../components/radio/r1.vue'
import EditBtn from '../../../../components/btn/edit.vue'
import LabelVue from './productLabel.vue'
import ImagesVue from './images.vue'
import { postapi, getapi } from '../../../../store/fetch'
const { VUE_APP_HOST } = process.env
export default {
  props: ['org', 'types', 'mode'],
  components: {
    LabelVue,
    ImagesVue,
    DateInput,
    TimeInput,
    PrinterVue,
    Checkbox,
    Checkbox2,
    SearchInput,
    Select,
    EditBtn,
    DelBtn,
    SaveBtn,
    RadioTop,
    Cube,
    File,
    Btns,
    Dialog,
    Table,
    Ingredient,
    DateRange
  },
  data () {
    const weekday = '週日_週一_週二_週三_週四_週五_週六'.split('_')
    return {
      wdoptions: '週日_週一_週二_週三_週四_週五_週六'.split('_').map((e, i) => { return { label: e, value: i } }),
      editprice: false,
      newprice: null,
      editItem: null,
      desc: null,
      VUE_APP_HOST,
      subpage: '商品內容',
      edit: false,
      options: [],
      option: [],
      optitem: null,
      optitems: [],
      editopt: false,
      editdesc: false,
      editarea: false,
      editSWD: false,
      editAdd: false,
      usage: '加價',
      searchText: null,
      rows: [],
      add: [],
      area: [],
      onsaleDay: [],
      weekday
    }
  },
  computed: {
    ...mapState({
      restaurants: 'restaurants',
      usages: 'usages'
    })
  },
  async mounted () {
    this.options = await getapi('options')
    await this.getdata()
  },
  watch: {
    org: {
      handler () {
        this.editprice = false
        this.editdesc = false
        this.editopt = false
        this.editAdd = false
        this.editSWD = false
        this.edit = false
        const { image, name, name2, type, category, price, unit, id, id2, onsaleTime } = JSON.parse(JSON.stringify(this.org))
        this.editItem = { image, name, name2, type, category, price, unit, id, id2, onsaleTime: onsaleTime || { start: '00:00', end: '23:59' } }
      },
      immediate: true
    },
    async usage () { await this.getdata() },
    async searchText () { await this.getdata() }
  },
  methods: {
    async saveprice () {
      if (this.editprice === 'new') {
        const r = await postapi(`rest_product/${this.mode}/price/${this.org._id}`, {
          ...this.newprice,
          startTime: this.moment(this.newprice.startTime).startOf('day').toISOString(),
          expireTime: this.moment(this.newprice.expireTime).endOf('day').toISOString()
        })
        if (r) {
          this.$emit('priceNew', r)
          this.editprice = false
        }
      } else if (this.editprice === 'shift-start') {
        const r = await postapi(`rest_product/${this.mode}/TimeShift/${this.org._id}`, {
          time: this.moment(this.newprice.time).startOf('day').toISOString(),
          type: 'start'
        })
        if (r) {
          this.$emit('updateMulti', r)
          this.editprice = false
        }
      } else if (this.editprice === 'shift-expire') {
        const r = await postapi(`rest_product/${this.mode}/TimeShift/${this.org._id}`, {
          time: this.moment(this.newprice.time).endOf('day').toISOString(),
          type: 'expire'
        })
        if (r) {
          this.$emit('updateMulti', r)
          this.editprice = false
        }
      } else if (this.editprice === 'excludeRange0') {
        const r = await postapi(`rest_product/${this.mode}/exclude/${this.org._id}`, {
          range: {
            start: this.moment(this.newprice.start).startOf('day').toISOString(),
            end: this.moment(this.newprice.end).endOf('day').toISOString()
          },
          type: 'excludeRange0'
        })
        if (r) {
          this.$emit('updateMulti', r)
          this.editprice = false
        }
      } else if (this.editprice === 'excludeRange1') {
        const r = await postapi(`rest_product/${this.mode}/exclude/${this.org._id}`, {
          range: {
            start: this.moment(this.newprice.start).startOf('day').toISOString(),
            end: this.moment(this.newprice.end).endOf('day').toISOString()
          },
          type: 'excludeRange1'
        })
        if (r) {
          this.$emit('updateMulti', r)
          this.editprice = false
        }
      }
    },
    async savedesc () {
      const r = await postapi(`rest_product/${this.mode}/${this.org._id}`, { description: this.desc })
      console.log('desc', r)
      if (r) {
        this.$emit('update', r)
        this.editdesc = false
      }
    },
    async saveoption () {
      const option = this.option
      const r = await postapi(`rest_product/${this.mode}/${this.org._id}`, { option })
      console.log('option', r)
      if (r) {
        this.$emit('update', r)
        this.editopt = false
      }
    },
    async saveSWD () {
      console.log('this.area', this.onsaleDay)
      const onsaleDay = this.onsaleDay
      console.log('this.onsaleDay', onsaleDay)
      const r = await postapi(`rest_product/${this.mode}/${this.org._id}`, { onsaleDay })
      console.log(r)
      if (r) {
        this.$emit('update', r)
        this.editSWD = false
      }
    },
    async savearea () {
      console.log('this.area', this.area)
      const area = this.area
      console.log('this.area', area)
      const r = await postapi(`rest_product/${this.mode}/${this.org._id}`, { area })
      console.log(r)
      if (r) {
        this.$emit('update', r)
        this.editarea = false
      }
    },
    async saveadd () {
      const r = await postapi(`rest_product/${this.mode}/${this.org._id}`, { add: this.add })
      console.log(r)
      if (r) {
        this.$emit('update', r)
        this.editAdd = false
      }
    },
    async save () {
      const { image, name, name2, type, category, price, unit, id, onsaleTime } = this.editItem
      const r = await postapi(`rest_product/${this.mode}/${this.org._id}`, { image, name, name2, type, category, price, unit, id, onsaleTime })
      console.log(r)
      if (r) {
        this.$emit('update', r)
        this.edit = false
      }
    },
    async getdata () {
      const params = {}
      if (this.usage) params.type = this.usage
      if (this.searchText) params.searchText = this.searchText
      this.rows = await getapi(`rest_product/${this.mode}?${new URLSearchParams(params)}`)
    }
  }
}
</script>
<style lang="scss">
.cube-body {
  select {
    text-align-last: center;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.priceShift {
  width: 35px;
  height: 35px;
  background-color: #FFFFFF;
  margin-left: 20px;
  border-radius: 20px;
  color: var(--color-pri);
  font-weight: 700;
  // &::before {
  //   content: '';
  //   width: 35px;
  //   height: 35px;
  //   background-color: var(--color-pri);
  //   mask-image: url(svg/btn/sort.svg);
  //   mask-position: center;
  //   mask-repeat: no-repeat;
  //   mask-size: 16px;
  //   transform: rotate(90deg);
  //   display: inline-block;
  // }
}
.priceTimeline {
  display: flex;
  margin-top: 40px;
  &>div {
    flex: 1;
    background-color: #C4C4C4;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
  }
  &>div.currentTime {
    flex: 2;
    background-color: #517FA4;
    padding-block: 10px;
  }
  #startTime, #expireTime {
    flex: unset;
    width: 5px;
    position: relative;
    background-color: #FFFFFF;
    border: 1px solid #CACACA;
    color: #5E5E5E;
    font-weight: 700;
    &::before {
      content: attr(content);
      display: inline-flex;
      position: absolute;
      width: fit-content;
      white-space: nowrap;
      left: -2.5em;
      top: calc(-70%);
    }
  }
}
#selectitemsCube {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
}
.selectitems {
  display: flex;
  gap: 20px;
  font-size: 20px;
  &>div:nth-child(1) {
    width: 70px;
    min-width: 70px;
    color: var(--color-pri);
    font-weight: 700;
    text-align: end;
  }
  &>div:nth-child(2) {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 20px;
  }

}
.printersetting {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-block: 27px;
  gap: 30px 21px;
}
.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 20px 10px 20px;
  border-radius: 3px;
  border: 1px solid var(--color-pri);
  gap: 15px;
  .area {
    border: 1px solid var(--color-pri);
    padding: 10px;
    //styleName: Noto TC/Medium/16;
    font-family: Noto Sans TC;
    font-size: 16px;
    font-weight: 500;
    line-height: 15px;
    letter-spacing: 2px;
    color: var(--color-pri);

  }
}
#descriptionModify {
  textarea, p {
    font-family: Noto Sans TC;
    text-align: start;
    font-size:  16px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 0;
  }
  textarea {
    width: 100%;
    border: 1px solid #CACACA;
    border-radius: 3px;
    padding: .25em .5em;
  }
}
.ingredbox {
  width: 100%;
  height: 100%;
  margin-top: 15px;
}
input[type=checkbox] {
  appearance: none;
  width: 30px;
  height: 30px;
  background-color: #FFFFFF;
  border: 1px solid var(--color-pri);
  border-radius: 5px;
  &:checked {
    background-color: var(--color-pri);
    background-image: url(/svg/checkbox/checkmark.svg);
    background-position: center;
    background-repeat: no-repeat;

  }
}
.dialog-body {
  display: grid;
  grid-template-rows: 64px 1fr 85px;
  height: 645px;
  width: 607px;
  &>div:nth-child(2) {
    overflow-y: auto;
  }
}
.optionsProd {
  width: calc(100%);
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-height: 55px;
  // border: 1px solid var(--color-pri);
  // border-radius: 5px;
}
.presetoptions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  &>div:nth-child(1) {
    font-size: 16px;
    color: var(--color-pri);
  }
}
.tags {
  min-height: 60px;
  width: calc(100%);
  height: -webkit-fill-available;
  border: 1px solid var(--color-pri);
  border-radius: 5px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  padding: 12px 17px;
  gap: 10px;
  &>div {
    font-weight: 500;
    font-size: 16px;
    font-size: 20px;
    letter-spacing: 2px;
    padding: 5px 8px;
    border: 1px solid var(--color-pri);
    color: var(--color-pri);
  }
  input[type=text] {
    height: 40px;
    width: 200px;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: #B9B9B9;
    border: none;
  }
}
.editOptions {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.singleSet {
  padding: 15px 28px 15px 36px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.title_name {
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  letter-spacing: 0.05em;
  color: #517FA4;
}
.img {
  width: 400px;
  height: 287.4px;
  background-color: var(--color-border);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.fields {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 25px;
  &>div{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &::before {
      content: attr(label);
      font-weight: 500;
      font-size: 16px;
      line-height: 15px;
      letter-spacing: 2px;
      color: #787878;
    }
    &::after {
      content: attr(info);
      font-weight: 500;
      font-size: 14px;
      line-height: 15px;
      letter-spacing: 2px;
      color: #CACACA;
    }
    &.blue::before {
      color: var(--color-pri);
      line-height: 27px;
      vertical-align: text-top;
    }
    font-weight: 500;
    font-size: 24px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
    gap: 6px;
  }
  input[type=text] {
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    height: 35px;
    text-align: center;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0.1em;
    color: #5E5E5E;
    position: relative;
  }
}
.cube-body {
  flex:1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-right: 60px;
  position: relative;
  padding-block: 25px 28px;
  padding-right: 70px;
  select {
    text-align-last: 'center';
    text-align: 'center';
  }
}
.topright {
  position: absolute;
  right: 20px;
  top: 13px;
}
.cube {
  margin-top: 20px;
  flex: 1;
  border: 1px solid var(--color-pri);
  min-height: 420px;
  height: fit-content;
  border-radius: 10px;
  width: -webkit-fill-available;
  display: grid;
  grid-template-rows: 1fr 47px;
  position: relative;

}
.foot {
  flex: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 28px 26px;
  height: 47px;
  border-top: 1px solid var(--color-pri);
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 2px;
  color: #B9B9B9;
}
</style>
